var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5716 15.2448C13.8356 13.8644 10.8897 10.9183 9.50519 7.17843C9.41667 6.94052 9.08333 6.94052 8.99481 7.17843C7.61445 10.9144 4.66826 13.8603 0.928426 15.2448C0.690525 15.3333 0.690525 15.6667 0.928426 15.7552C4.66437 17.1355 7.61034 20.0817 8.99481 23.8216C9.08333 24.0595 9.41667 24.0595 9.50519 23.8216C10.8855 20.0856 13.8317 17.1397 17.5716 15.7552C17.8095 15.6667 17.8095 15.3333 17.5716 15.2448Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.666 4.87991C20.9079 4.23033 19.5216 2.84389 18.8701 1.08397C18.8284 0.972012 18.6716 0.972012 18.6299 1.08397C17.9803 2.84205 16.5939 4.2284 14.834 4.87991C14.722 4.92157 14.722 5.07843 14.834 5.12009C16.5921 5.76967 17.9784 7.15611 18.6299 8.91603C18.6716 9.02799 18.8284 9.02799 18.8701 8.91603C19.5197 7.15795 20.9061 5.7716 22.666 5.12009C22.778 5.07843 22.778 4.92157 22.666 4.87991Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.db5ef9ed3bbcf2d70c06457b5de287dd.svg";
export { ForwardRef as ReactComponent };